import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { motion, AnimatePresence } from "motion/react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { CartProvider } from "./CartContext";
import { WishlistProvider } from "./WishlistContext";
import { CartDrawer } from "./CartDrawer";
import { ScrollToTopButton } from "./ScrollToTopButton";
import { ThemeInjector, useTheme } from "./ThemeInjector";
import { CustomerAuthProvider } from "./CustomerAuthContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function Layout() {
  const location = useLocation();
  const theme = useTheme();

  return (
    <CustomerAuthProvider>
      <CartProvider>
        <WishlistProvider>
          <ThemeInjector />
          <div className="min-h-screen" style={{ fontFamily: theme.fontBody, backgroundColor: theme.bg, color: theme.fg }}>
            <ScrollToTop />
            <Navigation />
            <CartDrawer />
            <main id="main-content" tabIndex={-1} className="outline-none">
              <AnimatePresence mode="wait">
                <motion.div
                  key={location.pathname}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -8 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <Outlet />
                </motion.div>
              </AnimatePresence>
            </main>
            <Footer />
            <ScrollToTopButton />
            <Toaster
              position="bottom-center"
              toastOptions={{
                style: {
                  fontFamily: theme.fontBody,
                  fontSize: "14px",
                  background: theme.fg,
                  color: theme.bg,
                  border: "none",
                  borderRadius: "12px",
                },
              }}
            />
          </div>
        </WishlistProvider>
      </CartProvider>
    </CustomerAuthProvider>
  );
}